var site = site || {};
site.shadeFilter = site.shadeFilter || {};
var presentAfterpay = presentAfterpay || {};

(function($) {
  Drupal.behaviors.spp = {
    attach: function(context) {
      var productData = page_data['catalog-spp']['products'][0];
      var product_images = productData.MEDIUM_IMAGE;
      var productName = productData.PROD_RGN_NAME;

      //setup carousel
      var $productImages = $('.spp-product__images', context);
      var $productImage = $('img', $productImages);
      var $productImageCount = $productImage.length;
      var enableDiscPrice = Drupal.settings.product_info.show_discount_price;

      var isEsteeEdit = $('body').hasClass('brand-estee_edit');
      var isSPPage = $('.spp-product').length > 0;
      var isSPPVideo = 0;
      var esteeEditVideo = 0;
      var $videoImageContainer = $();
      var sppPicker = false;
      var isRTL = site?.direction?.isRTL || false;

      // add video
      if (isEsteeEdit || isSPPage) {
        try {
          esteeEditVideo = productData.VIDEO_FILE[0];
          isSPPVideo = productData.VIDEO_FILE[0];
        } catch (e) {
          // console.warn('Product video failed load');
        }

        if (esteeEditVideo) {
          var altVideoImageSize = Drupal.settings.globals_variables.product_alt_video_image_size;
          var videoPath = '/media/export/cms/products/' + altVideoImageSize + '/';
          var videoPathImage = 'el_video_' + productData.PRODUCT_ID + '_' + altVideoImageSize + '_0.jpg';
          var videoClass = isSPPage ? 'video-launcher' : 'video-play video-launcher';
          videoPath = videoPath + videoPathImage;

          var $videoLink = $('<a/>', {
            class: videoClass,
            href: '//www.youtube.com/embed/' + esteeEditVideo + '?autoplay=1&rel=0',
            html: '<img src="' + videoPath + '" alt="' + productName + '" loading="lazy" />'
          });

          $videoImageContainer = $('<div/>', {
            class: 'spp-product__image spp-product__video js-prod-level-video',
            html: $videoLink
          }).attr('data-thumb', videoPath).attr('data-video', esteeEditVideo);

          $productImages.append($videoImageContainer);
          var colorBoxClassName = isEsteeEdit ? 'colorbox__estee-edit' : 'colorbox__spp-video';
          $('.video-launcher', context).colorbox({iframe: true, width: '100%', height: '100%', className: colorBoxClassName});
        }
      }

      site.product.view.full({productData: productData});
      site.product.view.skus();

      $productImage.each(function() {
        var smooshCheck = $(this).attr('src').indexOf('smoosh');
        if (smooshCheck > 1) {
          $(this).parent().addClass('smoosh');
        }
      });

      if (isSPPage) {
        $productImage = $('img', $productImages);
        $productImageCount = $productImage.length;
      }

      if ($productImageCount > 1) {
        $productImages.slick({
          dots: true,
          arrows: false,
          rtl: isRTL,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          onAfterChange: function(args) {
            if (Drupal.settings.analytics.analytics_integrated) {
              $(document).trigger('SLICKCHANGE', args.$slides.get(args.currentSlide));
            }
          }
        });
      }
      $productImages.on('sku:select', function(e, skuData) {
        var newImageArray = [];
        newImageArray = skuData.MEDIUM_IMAGE;
        var newSmoosh = skuData.XS_SMOOSH;
        var startAtSmoosh = 0;
        var currentSlide = 0;
        var slideCount = 0;
        var prodIndex = 1;
        // Intialize the Slicker if default SKU and product doesn't have ALT image and Non default Sku has ALT image
        if ($productImageCount < 1 && newImageArray.length > 1) {
          $productImages.slick({
            dots: true,
            arrows: false,
            infinite: false,
            rtl: isRTL,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
        if (productData.shaded && newSmoosh.length) {
          currentSlide = $productImages.slick('slickCurrentSlide');
          if ($productImages.eq(currentSlide).hasClass('smoosh')) {
            startAtSmoosh = 1;
          }
          newImageArray.splice(1, 0, newSmoosh);
        }
        // To push product level images into images array
        if (product_images !== undefined) {
          if (!_.isNull(product_images) && product_images.length > 0) {
            newImageArray = newImageArray.concat(product_images);
          }
        }

        // getting odd duplicate, make unique
        newImageArray = _.uniq(newImageArray);
        // current slide count
        slideCount = $('.slick-dots li', $productImages).length;
        // create new list
        for (var i = slideCount - 1; i >= 0; i--) {
          $productImages.slick('slickRemove', i);
        }
        var colorBoxClassName = isEsteeEdit ? 'colorbox__estee-edit' : 'colorbox__spp-video';
        $(newImageArray).each(function(index, val) {
          var smooshClass = '';
          var newSlide;
          // Add a class only for ALT Images
          if (index > 0) { // Exclude class Name for product default image
            if (val.indexOf('el_smoosh') > 1) { // add smoosh class
              smooshClass = 'smoosh';
            } else if (val.indexOf('el_sku') > 1) { // add SKU level Alt image class
              index = productData.shaded ? index - 1 : index;
              smooshClass = 'js-sku-level-image-' + index;
            } else if (val.indexOf('el_prod') > 1) { // add Product level Alt image class
              smooshClass = 'js-prod-level-image-' + prodIndex;
              prodIndex++;
            }
          }
          // add slide
          if (isEsteeEdit || isSPPVideo) {
            newSlide = '<div class="spp-product__image ' + smooshClass + '" data-thumb="' + val + '"><img src="' + val + '" alt="' + productName + '"' + (index !== 0 ? 'loading="lazy"' : '') + ' width="308" height="424" /></div>';
          } else {
            newSlide = '<div class="spp-product__image ' + smooshClass + '"><img src="' + val + '" alt="' + productName + '"' + (index !== 0 ? 'loading="lazy"' : '') + ' width="308" height="424" /></div>';
          }
          // If Slicker enabled use SliceAdd method else add only one Image
          if ($productImageCount > 1 && newImageArray.length > 1) {
            $productImages.slick('slickAdd', newSlide);
          } else {
            $productImages.html(newSlide);
          }
        });

        if ((isEsteeEdit || isSPPVideo) && esteeEditVideo) {
          $('.spp-product__images', context).slick('slickAdd', $videoImageContainer);
          $('.video-launcher', context).colorbox({iframe: true, width: '100%', height: '100%', className: colorBoxClassName});
        }

        if (startAtSmoosh) {
          // go to the second slide 'smoosh mode'
          $productImages.slick('slickGoTo', 1);
        }
      });
      //shaded
      if (productData.shaded) {
        if (!Drupal.settings.globals_variables.enable_deep_link) {
          sppPicker = new site.ShadePicker(productData);
        }
        site.shadeFilter.init();
        new site.SmooshSlider({
          containerNode: $('.smoosh-list'),
          productData: productData
        });
        // get SKU Base ID from url and change shade based on that
        var skuBaseIDfromURL = parseInt(window.location.hash.substr(1));
        if (skuBaseIDfromURL.length > 1 && typeof skuBaseIDfromURL === 'number') {
          var skuDataFromURL = _.find(productData.skus, function(sku) {
            return sku.SKU_BASE_ID === skuBaseIDfromURL;
          });
          $productImages.trigger('sku:select', skuDataFromURL);
          if (sppPicker !== false) {
            sppPicker.updateSwatches(skuBaseIDfromURL);
            sppPicker.updateSelects(skuBaseIDfromURL);
          }
        }
        site.shadeFilter.filter();
      }
      var skuData = productData.skus;
      // Single SKU product use Case. Ex: Sized has Single Sku, Non Sized and Non Shaded product type
      if (!productData.shaded && skuData.length === 1) {
        $productImages.trigger('sku:select', productData.skus[0]);
      }

      site.addFavoritesButton($('.js-add-to-favorites', context));

      //start closed
      $('.spp-product__additional-section', context).addClass('is_closed');

      $('.spp-product__additional-section-button', context).click(function(event) {
        event.preventDefault();
        $(this).parent('.spp-product__additional-section').toggleClass('is_closed');
      });

      $('.spp-product__detail-link', context).click(function(event) {
        event.preventDefault();
        var $sppAdditionalSection = $('.spp-product__additional-section:first', context);
        $sppAdditionalSection.removeClass('is_closed');
        $('html, body').animate({scrollTop: $sppAdditionalSection.offset().top - $('.page-header').outerHeight()}, 'slow');
      });

      var $quantitySelect = $('.spp-product__quantity', context);
      var $replenishmentSelect = $('.js-replenishment-select', context);
      var $sizeSelect = $('.spp-product__price-size-select', context);
      var $skintypeSelect = $('.spp-product__skintype-select', context);

      //size select init:

      //get skus to show from skintype
      //if size exists
      if ($sizeSelect.length && $skintypeSelect.length) {
        updateSizeSelect($sizeSelect, $skintypeSelect, productData);
        //$sizeSelect.selectBox();
      } else if ($sizeSelect.length && !$skintypeSelect.length) {
        $sizeSelect.removeClass('reference');
        if (enableDiscPrice) {
          updateRetailPriceValue($sizeSelect);
        }
        $sizeSelect.on('change', function() {
          var selectedSku = parseInt($(this).find('option:selected').attr('data-sku-base-id'));
          //console.log(selectedSku);
          // To be update on mobile retail price value
          if (enableDiscPrice) {
            updateRetailPriceValue($sizeSelect);
          }
          $(this).prev('.select-markdown').remove();
          $(this).removeClass('custom-markdown');
          if ($(this).find('option:selected').hasClass('option-discount-sale')) {
            var selectedElement = $(this).find('option:selected');
            var optionTextHtml = selectedElement.attr('data-markdown-price');
            $(this).before(optionTextHtml);
          }
          var skuData = _.find(productData.skus, function(sku) {
            return sku.SKU_BASE_ID === selectedSku;
          });
          site.skuSelect(skuData);
        });
      }
      function afterPayMessage() {
        var amount = null;
        if ($('.js-price-for-installment').length) {
          amount = $('.js-price-for-installment').has('.on-sale').length
            ? $('.on-sale').html().split('$')[1].replace('.', '')
            : $('.js-price-for-installment').html().split('$')[1].replace('.', '');
        } else if ($('.js-selectBox-label').length) {
          amount = $('.js-selectBox-label option:selected').text().split('$')[1].replace('.', '');
        }
        if (amount !== null && typeof presentAfterpay.afterpayConfig === 'function') {
          presentAfterpay.afterpayConfig(amount);
        }
      }
      $quantitySelect.change(function() {
        var quantity = $(this).val();
        site.qtySelect(productData.PRODUCT_ID, quantity);
        afterPayMessage();
        if (Drupal.settings.globals_variables.clearpay_uk) {
          Drupal.behaviors.clearPayMessageUKV1.initClearPay();
        }
      });

      // replenishment
      $replenishmentSelect.change(function() {
        var replVal = $(this).val();
        site.replSelect(productData.PRODUCT_ID, replVal);
      });

      // Initially reset to 0
      site.replSelect(productData.PRODUCT_ID, 0);

      // only use skintype as reference, set sku from size select
      $skintypeSelect.change(function() {
        if (typeof updateSizeSelect !== 'undefined') {
          updateSizeSelect($sizeSelect, $skintypeSelect, productData);
        }

        if ($sizeSelect.length && typeof updateSizeSelect !== 'undefined') {
          updateSizeSelect($sizeSelect, $skintypeSelect, productData);
          // inventory status update/reorder skin type selects
          var selectInvSorted = $sizeSelect.find('option').data('inventory') || false;
          if (!!selectInvSorted) {
            $(document).trigger('selectFirstShoppable');
          }
        } else {
          var selectedSku = parseInt($(this).find('option:selected').attr('data-skus'));
          //console.log(selectedSku);
          var skuData = _.find(productData.skus, function(sku) {
            return sku.SKU_BASE_ID === selectedSku;
          });
          site.skuSelect(skuData);
        }
      });

      if ($skintypeSelect.length && !$sizeSelect.length) {
        $skintypeSelect.trigger('change');
      }

      // Personalization SPP initialization
      if (Drupal.ELB.hasPersonalization()) {
        if (site.profile.mobile && site.profile.mobile.SPP) {
          site.profile.mobile.SPP(page_data['catalog-spp']);
        }
      }
    }// attach
  };

  function updateSizeSelect($sizeSelect, $skintypeSelect, productData) {
    $('option', $sizeSelect).prop('disabled', true);
    var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
    $(selectedSkus).each(function(index, val) {
      $('option', $sizeSelect).filter('[data-sku-base-id=' + val + ']').prop('disabled', false);
    });
    var $sizeSelectClone = $sizeSelect.clone();
    $sizeSelectClone.removeClass('reference');
    $('.sizeSelectClone').remove();
    $sizeSelectClone.addClass('sizeSelectClone');
    $('option:disabled', $sizeSelectClone).remove();
    $sizeSelect.parent().append($sizeSelectClone);
    $('.sizeSelectClone').change(function() {
      var selectedSku = parseInt($(this).find('option:selected').attr('data-sku-base-id'));
      var skuData = _.find(productData.skus, function(sku) {
        return sku.SKU_BASE_ID === selectedSku;
      });
      site.skuSelect(skuData);
    });
    $('.sizeSelectClone').trigger('change');
  }

  function updateRetailPriceValue(ele) {
    var retailPriceVal = ele.find('option:selected').attr('data-retail-price');
    ele.prev('.spp-product__retail-price.js-retail-price').html(retailPriceVal);
  }

  //CX-3730 Deep Link Implementation
  $(window).on('load', function() {
    if (Drupal.settings.globals_variables.enable_deep_link) {
      if (!page_data || !page_data['catalog-spp'] || !Array.isArray(page_data['catalog-spp']['products'])) return null;
      var productData = page_data['catalog-spp']['products'][0];
      if (productData.shaded) {
        var sppPicker = new site.ShadePicker(productData);
        sppPicker.shadeInit();
      }
    }
  });
})(jQuery);
